<template>
    <div>
        <!--    Dual Format WITH Links -->
        <b-list-group-item class="intake-dashboard-data mb-4 p-0" v-if="dual && dualLink">
            <div class="float-left force-box-size" :class="colorAccentClass">
                <i class="p-4 font-2xl" :class="[icon, colorIconClass]"></i>
            </div>

            <div class="text-right force-box-height">
                <b-row class="h-100">
                    <b-col class="dual-dashboard-clickable p-2" style="border-right: 1px solid lightgrey;">
                        <router-link tag="div" class="h-100 d-flex align-items-end justify-content-end"
                                     :class="{'pointer': clickable, 'dashboard-nav': clickable}" :to="to">

                            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-2 text-nowrap">{{ label }}</span>
                            <span :class="[colorDataClass, fontClass]" v-if="data !== null">{{ data }}</span>
                            <span :class="fontClass" v-else><b-spinner type="grow" small variant="secondary"></b-spinner></span>
                        </router-link>
                        <div class="dashboard-nav-highlight"></div>
                    </b-col>

                    <b-col class="dual-dashboard-clickable p-2">
                        <router-link tag="div" class="h-100 d-flex align-items-end justify-content-end"
                                     :class="{'pointer': clickable, 'dashboard-nav': clickable}" :to="to2">

                            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-2 text-nowrap">{{ label2 }}</span>
                            <span :class="[colorDataClass, fontClass]" v-if="data2 !== null">{{ data2 }}</span>
                            <span :class="fontClass" v-else><b-spinner type="grow" small variant="secondary"></b-spinner></span>
                        </router-link>
                        <div class="dashboard-nav-highlight"></div>
                    </b-col>
                </b-row>
            </div>


            <div class="dashboard-nav-highlight"></div>
        </b-list-group-item>

        
        <!--    Dual Format -->
        <b-list-group-item class="intake-dashboard-data mb-4 p-0"
                           :class="{'clickable': clickable, 'dashboard-nav': clickable}" :to="to" v-else-if="dual && !dualLink">
            <div class="float-left mr-1 force-box-size" :class="colorAccentClass"><i class="p-4 font-2xl"
                                                                                     :class="[icon, colorIconClass]"></i>
            </div>
            <div class="p-2 pr-3 text-right force-box-height d-flex">
                <b-row class="flex-fill align-items-stretch">
                    <b-col style="border-right: 1px solid lightgray;" class="d-flex align-self-stretch">
                        <div class="pl-3 text-right align-self-end flex-grow-1">
                            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-2 text-nowrap">{{ label }}</span>
                            <span :class="[colorDataClass, fontClass]" v-if="data !== null">{{ data }}</span>
                            <span :class="fontClass" v-else><b-spinner type="grow" small variant="secondary"></b-spinner></span>
                        </div>
                    </b-col>

                    <b-col class="d-flex align-self-stretch">
                        <div class="text-right align-self-end flex-grow-1">
                            <span class="text-muted text-uppercase font-weight-bold font-sub-label pr-2 text-nowrap">{{ label2 }}</span>
                            <span :class="[colorDataClass, fontClass]" v-if="data2 !== null">{{ data2 }}</span>
                            <span :class="fontClass" v-else><b-spinner type="grow" small variant="secondary"></b-spinner></span>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="dashboard-nav-highlight"></div>
        </b-list-group-item>

        <!--    Single Format -->
        <b-list-group-item class="intake-dashboard-data mb-4 p-0"
                           :class="{'clickable': clickable, 'dashboard-nav': clickable}" :to="to" v-else>
            <div class="float-left mr-1 force-box-size" :class="colorAccentClass"><i class="p-4 font-2xl"
                                                                                     :class="[icon, colorIconClass]"></i>
            </div>
            <div class="p-2 pr-3 text-right force-box-height d-flex flex-wrap justify-content-end align-items-baseline">
                <div class="overview-data">
                    <div v-for="item in overviewData" :key="item.label">
                        <template v-if="item.data !== undefined && item.data !== null">
                            <span class="font-data-label font-weight-bold">{{ item.label }}</span>
                            <span class="data-number ml-2">{{ item.data }}</span>
                            
                        </template>
                    </div>
                </div>
                <div class="text-muted text-uppercase font-weight-bold font-data-label flex-grow-1">{{ label }}</div>
                <span class="data-number pl-2" :class="colorDataClass" v-if="data !== null">{{ data }}</span>
                <span class="data-number" v-else><b-spinner type="grow" variant="secondary"></b-spinner></span>
            </div>
            <div class="dashboard-nav-highlight"></div>
        </b-list-group-item>
    </div>
</template>

<script>
export default {
    name: 'DashboardSideDataWidget',
    props: {
        label: String,
        label2: String,
        data: [Number, String],
        data2: [Number, String],
        overviewData: Array,
        icon: {
            type: String,
            default: 'fa-light fa-analytics',
        },
        dualLink: {
            type: Boolean,
            default: false,
        },
        dual: {
            type: Boolean,
            default: false,
        },
        clickable: Boolean,
        to: String,
        to2: String,
        colorAccent: {
            type: String,
            default: 'gray-700',
        },
        colorData: {
            type: String,
            default: 'dark',
        },
        colorIcon: {
            type: String,
            default: 'white',
        }
    },
    computed: {
        colorAccentClass() {
            return this.colorAccent !== '' ? 'bg-' + this.colorAccent : 'bg-gray-700';
        },
        colorDataClass() {
            return this.colorData !== '' ? 'text-' + this.colorData : 'text-dark';
        },
        colorIconClass() {
            return this.colorIcon !== '' ? 'text-' + this.colorIcon : 'text-white';
        },
        fontClass() {
            return this.dual ? 'data-number-dual' : 'data-number';
        }
    },
    watch: {
        data: function (newValue, oldValue) {
            // TODO: Add css to indicate data change
        },
        data2: function (newValue, oldValue) {
            // TODO: Add css to indicate data change
        }
    }
};
</script>

<style scoped>
.font-data-label {
    font-size: .5rem;
    line-height: .5rem;
}

.data-number {
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 2.5rem;
}

.data-number-dual {
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.5rem;
}

.font-sub-label {
    font-size: .5rem;
}

.overview-data {
    text-align: left;
    align-self: center;
}
.overview-data .data-number {
    font-size: 1.25rem;
    font-weight: bold;
    line-height: 1.25rem;
}


.intake-dashboard-data {
    padding: 0.3rem;
    border: 1px solid #d1d4d7;
}

.intake-dashboard-data.clickable {
    cursor: pointer;
}

.dual-dashboard-clickable {
    z-index: 0;
    transition: .2s ease;
}
.dual-dashboard-clickable:hover {
    background: #f8f9fa;
}

.dual-dashboard-clickable  .dashboard-nav-highlight,
.clickable .dashboard-nav-highlight {
    background: #20a8d8;
    height: 3px;
    position: absolute;
    z-index: -1;
    right: 100%;
    bottom: 0;
    left: 0;
    /*transition: all 0.2s ease;*/
}
.dual-dashboard-clickable:hover .dashboard-nav-highlight,
.clickable:hover .dashboard-nav-highlight {
    right: 0;
}

.force-box-size {
    width: 78px;
    height: 72px;
    text-align: center;
}

.force-box-height {
    height: 72px;
}

@media (min-width: 1400px) {
    .font-data-label {
        font-size: .6rem;
    }

    .data-number {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3.5rem;
    }

    .data-number-dual {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 1.5rem;
    }

    .font-sub-label {
        font-size: .6rem;
    }
}

@media (min-width: 1900px) {
    .font-data-label {
        font-size: .7rem;
    }

    .data-number {
        font-size: 2.3rem;
        font-weight: bold;
        line-height: 3.5rem;
    }

    .data-number-dual {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 1.5rem;
    }

    .font-sub-label {
        font-size: .6rem;
    }
}

/* Changed Data Animation */
@keyframes colorchange {
    0% {
        color: blue
    }
    100% {
        color: initial
    }
}

.changing {
    animation: colorchange 10s !important;
}
</style>